import type { AuthBrand } from '@ai-factory/auth-sdk';
import type { AppBrand } from '@ai-factory/ui-core';

export const brand: AppBrand = {
  applicationCode: 'platform_console',
  name: 'Platform Console',
  logo: {
    mark: '⬡',
    wordmark: 'PLATFORM CONSOLE',
    ariaLabel: 'AI Website Factory Platform Console',
  },
  palette: {
    light: {
      canvas: '#f3f6fa',
      surface: '#ffffff',
      surfaceElevated: '#ffffff',
      text: '#0b1220',
      muted: '#526074',
      border: '#d7dee8',
      primary: '#175cd3',
      primaryHover: '#124aa9',
      primaryText: '#ffffff',
      accent: '#84adff',
      focus: '#2563eb',
      success: '#168451',
      warning: '#a15c00',
      danger: '#c62835',
    },
  },
  typography: {
    ui: 'Inter, system-ui, sans-serif',
    display: 'Inter, system-ui, sans-serif',
    mono: '"IBM Plex Mono", ui-monospace, monospace',
  },
  navigation: [
    { label: 'Overview', path: '/', icon: 'home' },
    { label: 'Applications', path: '/applications', icon: 'grid' },
    { label: 'Organizations', path: '/organizations', icon: 'building' },
    { label: 'Audit', path: '/audit', icon: 'shield' },
  ],
  iconSet: 'precise 1.75px outline system icons',
  marketingStyle: 'operational grid, topology lines and restrained system status color',
  radius: '0.5rem',
  darkMode: 'supported',
};

export const authBrand: AuthBrand = {
  name: brand.name,
  eyebrow: 'AI Website Factory',
  tagline: 'Operate applications, access and platform health with confidence.',
  background: brand.palette.light.canvas,
  surface: brand.palette.light.surface,
  text: brand.palette.light.text,
  muted: brand.palette.light.muted,
  primary: brand.palette.light.text,
  primaryText: '#ffffff',
  accent: brand.palette.light.primary,
  motif: 'grid',
};
